import { GameType } from '@daymade/common-lib/dbEnums';
import { lineContainsDuplicates } from 'utils/LottoEntryValidator';

export const generateRandomNumbers = (
  numberRanges: number[],
  bonusNumberRanges: number[]
) => {
  const lineNumbers = generateRandomLineNumbers(numberRanges);
  const lineBonusNumbers = generateRandomLineNumbers(bonusNumberRanges);

  const mainNumbers = lineNumbers.sort((a, b) => a - b);

  const bonusNumbers = lineBonusNumbers.sort((a, b) => a - b);

  return {
    type: GameType.LOTTERY as const,
    main: mainNumbers,
    bonus: bonusNumbers,
  };
};

export const generateRandomLineNumbers = (numberRanges: number[]) => {
  let lineNumbers;

  do {
    lineNumbers = numberRanges.map((maxNumber) =>
      Math.floor(Math.random() * maxNumber + 1)
    );
  } while (lineContainsDuplicates(lineNumbers)); // If we're using a bonus ball, don't include the last number when checking for duplicates.

  return lineNumbers;
};
